import { cloneDeep, isEqual } from 'lodash'

import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, states } from '@/utils'

import button from '@/components/button'
import buttonRefresh from '@/components/button/refresh'
import pagination from '@/components/pagination'
import tasksFilter from '@/components/services/tasks/filter'
import tasksForm from '@/components/services/tasks/form'

function renderDialogBody(h) {
  return h(
    tasksForm,
    {
      props: {
        value: this.restData[Services.tasks].create.data,
        errors: this.restData[Services.tasks].create.errors
      },
      on: {
        input: event => {
          this.restData[Services.tasks].create.data = event
        },
        validation: event => {
          this.restData[Services.tasks].create.isValid = event
        }
      }
    }
  )
}
function renderDialogFooter(h) {
  return h(
    'div',
    {
      class: 'tasks-create__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat,
            disabled: this.restData[Services.tasks].create.state === states.loading
          },
          on: {
            click: () => {
              this.showDialog = false
            }
          }
        }
      ),
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.create'),
            loading: this.restData[Services.tasks].create.state === 'loading',
            disabled: !this.createDataIsValid,
            color: Colors.primary
          },
          on: {
            click: async () => {
              await this.createTask()
            }
          }
        }
      )
    ]
  )
}
function renderDialog(h) {
  let dialogMaxWidth
  if (this.viewport.breakpoint.mdUp) {
    dialogMaxWidth = 400
  }

  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate(`${Services.tasks}.dialogs.create`),
        value: this.showDialog,
        maxWidth: dialogMaxWidth
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    },
    [
      renderDialogBody.call(this, h),
      renderDialogFooter.call(this, h)
    ]
  )
}

function renderPresets(h) {
  if (Array.isArray(this.presets) && this.presets.length > 0) {
    return h(
      'div',
      {
        class: `${Services.tasks}-header__presets`
      },
      [
        this.presets.map(preset => {
          let presetColor
          if (isEqual(this.filter, preset.filter)) {
            presetColor = Colors.primary
          } else {
            presetColor = Colors.grey
          }

          return h(
            button,
            {
              props: {
                label: this.getTranslate(`${Services.tasks}.buttons.${preset.title}`),
                mode: buttonModes.flat,
                color: presetColor
              },
              on: {
                click: () => {
                  this.filter = cloneDeep(preset.filter)
                }
              }
            }
          )
        })
      ]
    )
  }
}
function renderButtonCreate(h) {
  if (this.$route.name === Services.billings) {
    if (this.canCreateTasksAsResellerUp) {
      return h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.create'),
            icon: icons.add,
            mode: buttonModes.flat,
            color: Colors.secondary
          },
          on: {
            click: () => {
              this.showDialog = true
            }
          },
          scopedSlots: {
            dialog: () => {
              return renderDialog.call(this, h)
            }
          }
        }
      )
    }
  }
}
function renderButtonRefresh(h) {
  return h(
    buttonRefresh,
    {
      props: {
        label: this.getTranslate(`${Services.tasks}.buttons.refresh`),
        tooltip: this.getTranslate(`${Services.tasks}.tooltips.refresh`),
        state: this.restData[Services.tasks].find.state,
        shortClickMethod: () => {
          return this.rest[Services.tasks].find()
        },
        longClickMethod: () => {
          return this.rest[Services.tasks].find({}, { noCache: true })
        }
      }
    }
  )
}
function renderActions(h) {
  return h(
    'div',
    {
      class: `${Services.tasks}-header__actions`
    },
    [
      renderButtonCreate.call(this, h),
      renderButtonRefresh.call(this, h)
    ]
  )
}
function renderHeaderContent(h) {
  return h(
    'div',
    {
      class: `${Services.tasks}-header__content`
    },
    [
      renderPresets.call(this, h),
      renderActions.call(this, h)
    ]
  )
}
function renderFilter(h) {
  return h(
    tasksFilter,
    {
      props: {
        value: this.filter,
        type: this.restData[Services.tasks].find.filter.type
      },
      on: {
        input: event => {
          this.filter = event
        }
      }
    }
  )
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: `${Services.tasks}-header`
    },
    [
      renderHeaderContent.call(this, h),
      renderFilter.call(this, h)
    ]
  )
}

function renderList(h) {
  if (this.restData[Services.tasks].find.pagination.total) {
    const component = item => {
      if (this.$scopedSlots.item) {
        return this.$scopedSlots.item({ item })
      }

      return this.$slots.item
    }
    if (this.viewport.breakpoint.lgUp) {
      return this.restData[Services.tasks].find.data.map(component)
    } else {
      return h(
        components['expansion-panels'],
        {
          props: { flat: true }
        },
        [ this.restData[Services.tasks].find.data.map(component) ]
      )
    }
  } else {
    return h(components.empty)
  }
}

function renderDivider(h) {
  if (this.restData[Services.tasks].find.pagination.total > 0) {
    return h(components.divider)
  }
}

function renderPagination(h) {
  if (this.restData[Services.tasks].find.pagination.total > 0) {
    return h(
      'div',
      {
        class: `${Services.tasks}-pagination`
      },
      [
        h(
          pagination,
          {
            props: {
              value: this.restData[Services.tasks].find.pagination,
              service: Services.tasks
            },
            on: {
              input: event => {
                this.restData[Services.tasks].find.pagination = event
              }
            }
          }
        )
      ]
    )
  }

  return h('div')
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.tasks}-holder`
    },
    [
      renderHeader.call(this, h),
      renderDivider.call(this, h),
      renderPagination.call(this, h),
      renderDivider.call(this, h),
      renderList.call(this, h),
      renderDivider.call(this, h),
      renderPagination.call(this, h)
    ]
  )
}
